import { defineStore } from 'pinia'
import cache from '@/utils/cache'
import type { RouteRecordRaw } from 'vue-router'
import { getUserInfo, login, logout, idcUserAuth } from '@/api/user'
import router, { filterAsyncRoutes } from '@/router'
import { TOKEN_KEY } from '@/enums/cacheEnums'
import { PageEnum } from '@/enums/pageEnum'
import { clearAuthInfo, getToken } from '@/utils/auth'
import { domesticConsumerRole } from '@/types/constant'
import { notEnteringUserRole, adminHideRouterIds } from '@/types/constant'
export interface UserState {
    token: string
    userInfo: Record<string, any>
    routes: RouteRecordRaw[]
    perms: string[]
    admin_main_id: string | number
}

const useUserStore = defineStore({
    id: 'user',
    state: (): UserState => ({
        token: getToken() || '',
        // 用户信息
        userInfo: {},
        // 路由
        routes: [],
        // 权限
        perms: [],
        // 主体ID
        admin_main_id: ''
    }),
    getters: {
        // 是否为普通用户
        isDomesticConsumer(): boolean {
            const role_id = this.userInfo.role_id ? this.userInfo.role_id : []
            return role_id.includes(domesticConsumerRole)
        }
    },
    actions: {
        resetState() {
            this.token = ''
            this.userInfo = {}
            this.perms = []
            this.routes = []
            // this.admin_main_id = ''
        },
        login(playload: any) {
            const { account, password } = playload
            return new Promise((resolve, reject) => {
                clearAuthInfo()
                login({
                    account: account.trim(),
                    password: password
                })
                    .then((data) => {
                        this.token = data.token
                        cache.set(TOKEN_KEY, data.token)
                        resolve(data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        logout() {
            return new Promise((resolve, reject) => {
                logout()
                    .then(async (data) => {
                        this.token = ''
                        await router.push(PageEnum.LOGIN)
                        clearAuthInfo()
                        resolve(data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                getUserInfo()
                    .then((data) => {
                        const { user } = data
                        const { role_id } = user

                        // 是否普通用户
                        const isUser = role_id.includes(domesticConsumerRole)

                        // 普通用户需根据备案状态设置路由
                        const userRouter = (): any[] => {
                            return notEnteringUserRole
                        }

                        // 管理员路由需去除多余路由
                        const adminRouter = (
                            menu: any[],
                            hideRouter: any[]
                        ): any[] => {
                            return menu.filter((item: any) => {
                                return !hideRouter.includes(item.id)
                            })
                        }

                        data.menu = isUser
                            ? userRouter()
                            : adminRouter(data.menu, adminHideRouterIds)

                        this.userInfo = data.user
                        this.perms = data.permissions
                        this.admin_main_id = data.admin_main_id
                        this.routes = filterAsyncRoutes(data.menu)
                        resolve(data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        idcUserAuthLogin(playload: any) {
            const { token, pwd } = playload
            const params = { token, pwd }
            return new Promise((resolve, reject) => {
                idcUserAuth(params)
                    .then((data) => {
                        this.token = data.token
                        cache.set(TOKEN_KEY, data.token)
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    }
})

export default useUserStore
